var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54167 13.4583H4.55104L11.475 6.53438L10.4656 5.525L3.54167 12.449V13.4583ZM2.125 14.875V11.8646L11.475 2.53229C11.6167 2.40243 11.7732 2.30208 11.9446 2.23125C12.116 2.16042 12.296 2.125 12.4844 2.125C12.6728 2.125 12.8558 2.16042 13.0333 2.23125C13.2109 2.30208 13.3644 2.40833 13.4937 2.55L14.4677 3.54167C14.6094 3.67153 14.7128 3.825 14.778 4.00208C14.8431 4.17917 14.8755 4.35625 14.875 4.53333C14.875 4.72222 14.8427 4.90237 14.778 5.07379C14.7133 5.24521 14.6098 5.40151 14.4677 5.54271L5.13542 14.875H2.125ZM10.9615 6.03854L10.4656 5.525L11.475 6.53438L10.9615 6.03854Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit-outline.f9661f34254643d918ed19240f2f1903.svg";
export { ForwardRef as ReactComponent };